import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import Keycloak from 'keycloak-js';

export const KeycloakAuthenticationGuard = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const keycloak = inject(Keycloak);

  // Force the user to log in if currently unauthenticated.
  if (!keycloak.authenticated) {
    // state.url is relative to base href, so remove the leading slash
    const target = state.url.startsWith('/', 0) ? state.url.substring(1) : state.url;
    const redirectUri = new URL(target, document.getElementsByTagName('base')[0].href).href;
    await keycloak.login({
      redirectUri
    });
  }
  return true;
};
